import { Tooltip } from '@mantine/core'
import { Pencil, Trash2 } from 'lucide-react'

interface ActionsCellProps {
  customStep: {
    customStepId: string
    label: string
  }
  onEdit: (customStep: any) => void
  onDelete: (customStep: any) => void
}

const ActionsCell = ({ customStep, onEdit, onDelete }: ActionsCellProps) => {
  return (
    <div className="flex flex-row items-center gap-4">
      <Tooltip label="Edit">
        <Pencil
          size={14}
          className="text-doubleNickel-gray-600 hover:text-doubleNickel-gray-500"
          onClick={(e) => {
            e.stopPropagation()
            onEdit(customStep)
          }}
        />
      </Tooltip>
      <Tooltip label="Delete">
        <Trash2
          size={14}
          className="text-red-500 hover:text-red-400"
          onClick={(e) => {
            e.stopPropagation()
            onDelete(customStep)
          }}
        />
      </Tooltip>
    </div>
  )
}

export default ActionsCell
